<template>
    <div class="share-landlord-info">
        <h1 v-if="isEnterprise" class="title">公司簡介</h1>
        <h1 v-else class="title">房東簡介</h1>
        <div class="share-landlord-info-item">
            <div class="shot-wrap">
                <div class="ring-bg" :class="{'user': !taskTaker && landlordInfo.audited, 'enterprise': isEnterprise}"></div>
                <div class="shot" v-if="isEnterprise">
                    <img v-if="companyShot" class="shot-img" :src="companyShot" alt="">
                    <img v-else class="shot-img" src="@/assets/img/shareHouse/shot.svg" alt="">
                    <!-- <img class="award" src="@/assets/img/shareHouse/award.svg" alt=""> -->
                </div>
                <div class="shot" v-else>
                    <img v-if="landlordInfo.landlordImage" class="shot-img" :src="imageUrl(landlordInfo.landlordImage)" alt="">
                    <img v-else class="shot-img" src="@/assets/img/shareHouse/shot.svg" alt="">
                    <!-- <img class="award" src="@/assets/img/shareHouse/award.svg" alt=""> -->
                </div>
            </div>
            <div v-if="isEnterprise" class="group">
                <div class="name-and-phone">
                    <div class="name">
                        {{enterpiseName}}
                    </div>
                </div>
                <div v-if="!taskTaker && landlordInfo.audited" class="certification-date">
                    認證時間：{{getFormatDate(enterpiseAuditedTime)}}
                </div>
            </div>
            <div v-else class="group">
                <div class="name-and-phone">
                    <div class="name">
                        {{landlordInfo.landlordName}}
                    </div>
                </div>
                <div v-if="!taskTaker && enterpiseAuditedStatus === 'NORMAL'" class="certification-date">
                    認證時間：{{getFormatDate(landlordInfo.auditTime)}}
                </div>
                <div v-if="taskTaker" class="certification-date">
                    受託人
                </div>
            </div>
        </div>
        <div class="certification-info">
            <!-- <div class="good-landlord">
                <img src="@/assets/img/shareHouse/award_orange.svg" alt="">
                優質房東
            </div> -->
            <div v-if="!taskTaker && landlordInfo.audited" class="certification">
                <img src="@/assets/img/shareHouse/check_blue.svg" alt="">
                飛豬認證
                <span class="detail">
                    (身份、電話號碼、電子郵件)
                </span>
            </div>
        </div>
        <div v-if="isEnterprise" class="about-me">
            <div class="title">
                <span>關於企業</span>
                <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close">
                    收起
                    <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
                </span>
            </div>
            <div v-if="!enterpiseIntro" style="color: #909090;">
                沒有提供
            </div>
            <div v-if="isClose" class="content">
                <div :class="{hide: enterpiseIntro.length > 300 || countBreakSign > 3}" v-html="enterpiseIntro.split('\n').join('<br>')"></div>
                <span v-if="isClose && enterpiseIntro.length > 300 || countBreakSign > 3 && $route.query.mode != 'contract'" @click="isClose=false" class="more">
                    詳細內容
                    <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
                </span>
            </div>
            <div v-else class="content" v-html="enterpiseIntro.split('\n').join('<br>')">
                <div v-html="enterpiseIntro.split('\n').join('<br>')"></div>
            </div>
            <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close close-down">
                收起
                <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
            </span>
        </div>
        <div v-else class="about-me">
            <div class="title">
                <span>關於我</span>
                <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close">
                    收起
                    <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
                </span>
            </div>
            <div v-if="!landlordInfo.introduction" style="color: #909090;">
                沒有提供
            </div>
            <div v-if="isClose" class="content">
                <div :class="{hide: landlordInfo.introduction.length > 300 || countBreakSign > 3}" v-html="landlordInfo.introduction.split('\n').join('<br>')"></div>
                <span v-if="isClose && landlordInfo.introduction.length > 300 || countBreakSign > 3 && $route.query.mode != 'contract'" @click="isClose=false" class="more">
                    詳細內容
                    <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
                </span>
            </div>
            <div v-else class="content" v-html="landlordInfo.introduction.split('\n').join('<br>')">
                <div v-html="landlordInfo.introduction.split('\n').join('<br>')"></div>
            </div>
            <span v-if="!isClose && $route.query.mode != 'contract'" @click="isClose=true" class="close close-down">
                收起
                <img src="@/assets/img/shareHouse/arrow_down_blue.svg" alt="" srcset="">
            </span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { 
    baseDomain,
} from "@/apis/api.js"; 

export default {
    data() {
        return{
            isClose: true
        }
    },
    mounted () {
        if(this.$route.query.mode == 'contract'){
            this.isClose = false
        }
    },
    methods: {
        imageUrl: function (url) {
            return baseDomain+url
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'年'+formatDate[5]+'月'+formatDate[6]+'日';
        },
        wordingLimit: function (str) {
            return str.substring(1,155)+'...'
        }
    },
    computed: {
        countBreakSign: function () {
            let introduction = this.landlordInfo.introduction
            return introduction.split('\n').length-1
        },
        ...mapGetters({
            landlordInfo: 'GET_SHARE_HOUSE_LANDLORD_INFO',
            taskTaker: 'GET_SHARE_HOUSE_TASK_TAKER',
            isEnterprise: 'GET_SHARE_HOUSE_ENTERPRISE',
            enterpiseName: 'GET_SHARE_HOUSE_ENTERPRISE_NAME',
            enterpiseAuditedTime: 'GET_SHARE_HOUSE_ENTERPRISE_AUDITED_TIME',
            enterpiseAuditedStatus: 'GET_SHARE_HOUSE_ENTERPRISE_AUDITED_STATUS',
            enterpiseIntro: 'GET_SHARE_HOUSE_ENTERPRISE_INTRO',
            companyShot: 'GET_SHARE_HOUSE_ENTERPRISE_SHOT'
        })
    },
}
</script>
<style lang="scss" scoped>
    .share-landlord-info{
        position: relative;
        width: 100%;
        margin-bottom: -25px;
        h1.title{
            margin-bottom: 20px;
            font-size: 28px;
            color: #3a455f;
        }
        .share-landlord-info-item{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            .shot-wrap{
                position: relative;
                width: 70px;
                height: 70px;
                margin-right: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                .shot{
                    display: flex;
                    align-items: center;
                    .shot-img{
                        width: 100%;
                        background: #fff;
                        position: absolute;
                    }
                }
                .ring-bg{
                    width: 100%;
                    height: 100%;
                    background-repeat: no-repeat;
                    background-size: cover;
                    z-index: 5;
                    &.user{
                        background: url('../../assets/img/shareHouse/shot/user_intro.svg');
                    }
                    &.enterprise{
                        background: url('../../assets/img/shareHouse/shot/user_enterprise.svg');
                    }
                    &.tasker{
                        background: url('../../assets/img/shareHouse/shot/tasker.svg');
                    }
                }
                .shot{
                    position: absolute;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    .shot-img{
                        width: 100%;
                    }
                    .award{
                        position: absolute;
                        position: absolute;
                        bottom: -11px;
                        right: -5px;
                    }
                    
                }
            }
            // .shot-wrap{
            //     width: 60px;
            //     height: 60px;
            //     margin-right: 18px;
            //     display: flex;
            //     align-items: center;
            //     justify-content: center;
            //     .shot{
            //         position: relative;
            //         /* margin-right: 28px; */
            //         -webkit-box-sizing: border-box;
            //         box-sizing: border-box;
            //         /* padding: 2px; */
            //         width: 54.5px;
            //         height: 54.5px;
            //         border-radius: 50%;
            //         overflow: hidden;
            //         display: flex;
            //         align-items: center;
            //         justify-content: center;
            //         top: 0.3px;
            //         left: 0.2px;
            //         .shot-img{
            //             width: 100%;
            //             /* height: 100%; */
                        
            //         }
            //         .award{
            //             position: absolute;
            //             position: absolute;
            //             bottom: -11px;
            //             right: -5px;
            //         }
                    
            //     }
            //     // .shot.good{
            //     //     background-image: linear-gradient(to bottom, #9defff, #3fccfc);  
            //     // }
            // }
            .group{
                .name-and-phone{
                    display: flex;
                    align-items: center;
                    .name{
                        font-size: 22px;
                        margin-right: 16px;
                    }
                }
                .certification-date{
                    color: #909090;
                    margin-top: 8px;
                    font-size: 16px;
                }
            }
        }
        .certification-info{
            display: flex;
            align-items: center;
            margin-bottom: 25px;
            .good-landlord{
                display: flex;
                align-items: center;
                color: #909090;
                margin-right: 16px;
                img{
                    margin-right: 6px;
                }
            }
            .certification{
                display: flex;
                align-items: center;
                color: #3fccfc;
                margin-right: 16px;
                .detail{
                    margin-left: 4px;
                    color: #909090;
                }
                img{
                    margin-right: 6px;
                }
            }
            .task-taker{
                color: #909090;
            }
        }
        .about-me{
            margin-bottom: 25px;
            .close{
                font-size: 14px;
                display: flex;
                align-items: center;
                color: #2db2ff;
                font-weight: 400;
                cursor: pointer;
                img{
                    margin-left: 5px;
                    transform: rotate(180deg);
                }
            }
            .close-down{
                bottom: 3px;
                right: 0;
                position: absolute;
            }
            .title{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 10px;
                
            }
            .content{
                // display: flex;
                // align-items: center;
                line-height: 1.63;
                font-size: 16px;
                word-break: break-word;
                white-space: break-spaces;
                display: flex;
                flex-direction: column;
                .hide{
                    height: 100px;
                    overflow: hidden;
                }
                .more{
                    position: relative;
                    color: #2db2ff;
                    cursor: pointer;
                    font-size: 14px;
                     display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-top: 8px;
                    img{
                        margin-left: 2px;
                    }
                }
                .close{
                    position: absolute;
                    right: 0px;
                    bottom: 3px;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    color: #2db2ff;
                    font-weight: 400;
                    cursor: pointer;
                    img{
                        margin-left: 5px;
                        transform: rotate(180deg);
                    }
                }
                img{
                    margin-right: 10px;
                }
            }
        }
    }
    @media (max-width: 992px) {
        .share-landlord-info{
            h1.title{
                margin-bottom: 16px;
                font-size: 20px;
            }
            .certification-info{
                align-items: flex-start;
                justify-content: flex-start;
                flex-direction: column;
                margin-bottom: 21px;
                .good-landlord{
                    margin-bottom: 12px;
                }
            }
            .about-me{
                margin-bottom: 25px;
                .content{
                    line-height: 1.86;
                    font-size: 14px;
                    
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/landlordInfo.vue